import * as joda from "@js-joda/core";
import h from "trader-hyperscript";
import { Router } from "trader.ts/router";
import { find_teachers_with_lessondates } from "../../../sql/classy/teachers";
import { internalteacherid, teacherid } from "../../../sql/classy/types";
import * as style from "../../../styles/style.css.classes";
import { isNil } from "../../lib/istype";
import { ddMMM, renderFirstNameLastName } from "../../render";
import { renderClassyPage } from "../../renderclassypage";
import * as routes from "../../routes";
import { needsAdmin } from "../../security";
import { translateWeekday } from "../../translations_specific";
import { classyTsContext } from "../../types";

export function renderTeacherListHeader() {
  return (
    <tr>
      <th>{"docent"}</th>
      <th className={style.remove_on_phone}>{"Vorige lesdag"}</th>
      <th>{"vandaag"}</th>
      <th>{"volgende lesdag"}</th>
      <th>{"Jaarkalender"}</th>
    </tr>
  );
}

export function renderTeacherListItem(t: {
  id: teacherid;
  firstname: string;
  lastname: string;
  internalteacherid: internalteacherid | null;
  previous_lesson_date: joda.LocalDate | null;
  next_lesson_date: joda.LocalDate | null;
  lessons_today: joda.LocalDate | null;
}) {
  function renderDate(d: joda.LocalDate) {
    return translateWeekday(d.dayOfWeek()).substring(0, 2) + " " + ddMMM(d);
  }

  return (
    <tr>
      <td>
        {!isNil(t.internalteacherid) ? (
          <a
            href={routes.teacher_editRoute.link({
              internalteacherid: t.internalteacherid,
            })}
          >
            <b>{renderFirstNameLastName(t)}</b>
          </a>
        ) : (
          <b>
            {renderFirstNameLastName(t) + " (" + "Vervanger" + ")"}
          </b>
        )}
      </td>

      <td>
        {t.previous_lesson_date ? (
          <a
            href={routes.teacher_lessonrosterRoute.link({
              date: t.previous_lesson_date,
              mode: undefined,
              teacherid: t.id,
            })}
          >
            {renderDate(t.previous_lesson_date)}
          </a>
        ) : (
          <span></span>
        )}
      </td>

      <td>
        {t.lessons_today ? (
          <a
            href={routes.teacher_lessonrosterRoute.link({
              date: t.lessons_today,
              mode: undefined,
              teacherid: t.id,
            })}
          >
            {renderDate(t.lessons_today)}
          </a>
        ) : (
          <span>{"Geen les"}</span>
        )}
      </td>

      <td>
        {t.next_lesson_date ? (
          <a
            href={routes.teacher_lessonrosterRoute.link({
              date: t.next_lesson_date,
              mode: undefined,
              teacherid: t.id,
            })}
          >
            {renderDate(t.next_lesson_date)}
          </a>
        ) : (
          <span></span>
        )}
      </td>

      <td>
        <a
          href={routes.yearcalendarTeacherRoute.link({
            teacherid: t.id,
            periodid: undefined,
          })}
        >
          {"Jaarkalender"}
        </a>
      </td>
    </tr>
  );
}

export function registerTeacher_listRoutes(router: Router<classyTsContext>) {
  router.page(
    routes.teacher_listRoute,
    needsAdmin,
    async function (ctx, { include_external_and_deactivated }, token) {
      const db = ctx.db;

      const includeExternalAndDeactivated =
        include_external_and_deactivated || false;
      const title = "Docenten";

      const teachers = await find_teachers_with_lessondates(db, {
        query: "",
        include_external_and_deactivated: includeExternalAndDeactivated,
        today: joda.LocalDate.now(),
      });

      const topLinks = (
        <div style="text-align: right;margin-bottom: 8px;">
          <a
            href={routes.teacher_editRoute.link({
              internalteacherid: undefined,
            })}
          >
            <button className={style.button_accent}>
              {"+ " + "Nieuwe docent"}
            </button>
          </a>
          <br />
          {includeExternalAndDeactivated ? (
            <span style="font-size: 12px;">
              {"Vervangers en inactieve docenten worden getoond"}
            </span>
          ) : (
            <a
              style="font-size: 12px;"
              href={routes.teacher_listRoute.link({
                include_external_and_deactivated: true,
              })}
            >
              {"Toon vervangers en inactieve docenten"}
            </a>
          )}
        </div>
      );

      const tableHeader = renderTeacherListHeader();

      return renderClassyPage(
        ctx,
        token,
        "Teachers",
        <h1>{title}</h1>,
        title,
        <main style="max-width: 1280px;">
          {teachers.length === 0 ? (
            <a
              href={routes.teacher_editRoute.link({
                internalteacherid: undefined,
              })}
            >
              {"Je hebt nog geen docenten aangemaakt. Klik hier om je eerste docent in te geven."}
            </a>
          ) : (
            <div>
              {topLinks}
              <table>
                {tableHeader}
                {teachers.map(renderTeacherListItem)}
              </table>
            </div>
          )}
        </main>,
      );
    },
  );
}
